/**
 * @param {HTMLElement} el
 * @param {string} message
 */
export const showError = (el, message) => {
  const error = el.shadowRoot?.querySelector('.error')
  if (!error) {
    return
  }
  el.shadowRoot?.querySelectorAll('input, select').forEach((child) => {
    child.classList.add('error')
  })
  error.textContent = message
}
